<template>
  <div>
    <v-navigation-drawer temporary location="right" v-model="rightDrawer">
      <v-list>
        <v-list-item>
          <v-list-item-action>
            <v-icon>compare_arrows</v-icon>
          </v-list-item-action>
          <v-list-item-title>Switch drawer (clitemme)</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  components: {},
  data() {
    return {
      rightDrawer: false,
    };
  },
});
</script>
